module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dragonDetail"
  }, [_c('mt-header', {
    attrs: {
      "title": "顶峰 开化龙顶 2017明前茶 绿茶  50g 黄罐单罐"
    }
  }, [_c('mt-button', {
    attrs: {
      "icon": "back"
    },
    on: {
      "click": _vm.goBack
    },
    slot: "left"
  }, [_vm._v("返回")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e957320","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/dragonDetail.vue
// module id = 224
// module chunks = 1